<script>
  const serverSrc = 'cloud.ecardplay.com';
  const AuthorizationCode = '12345678';
  const hasEnter = false;
  const CompanyName = "广州旺猫信息科技有限公司";
  const VersionTime = "2018-2025";
  const Name = "旺猫游乐云";
  const Version = "V1.4.4";
  const Tel = '电话：020-31562342';
  const Printer = "";
  const MemberCardNum = "";
  const MemberCardNumGUID = "";
  const OfficialWebsite = "http://www.ecardplay.com/"; //官网
  const MemberGlobalSet = {
    IsUsePasswordDeduction: false,
    DefaultPassword: "123456",
  };
  const PhoneVersion = "PC"; //硬件版本
  const OS =null; //硬件版本
  export default {
    Name, //客户端名
    CompanyName,
    AuthorizationCode, //授权码
    serverSrc, //服务器地址
    hasEnter, //用户登录状态
    Version, //版本号
    Tel, //联系电话
    Printer, //打印内容
    MemberCardNum, //卡号
    VersionTime, //版本时间
    OfficialWebsite, //官网
    MemberGlobalSet, //会员设置
    PhoneVersion, //硬件版本
    OS,//系统类型
    SetMemberCardNum(MemberCardNum) {
      this.MemberCardNum = MemberCardNum;
    },
    SetMemberCardNumGUID(MemberCardNumGUID) {
      this.MemberCardNumGUID = MemberCardNumGUID;
    },
    SetPrinter(Printer) {
      this.Printer = Printer;
    },
    SetMemberGlobalSet(MemberGlobalSet) {
      this.MemberGlobalSet = MemberGlobalSet;
    },
    SetPhoneVersion(PhoneVersion) {
      this.PhoneVersion = PhoneVersion;
    },
    SetOS(OS) {
      this.OS = OS;
    },
  }
</script>



// WEBPACK FOOTER //
// src/Global/Global.vue